import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { forYou, notForYou } from '../data/landing';
export function Audience() {
  return <section className="w-full border-y border-teal/10 bg-paper py-16 lg:py-24" data-id="element-12" data-mp="3p26wcbtajhqo">
      <div className="mx-auto max-w-6xl px-6" data-id="element-13" data-mp="6vixh3ou3qtg">
        <h2 className="max-w-readable font-serif text-3xl font-semibold leading-tight text-ink sm:text-4xl" data-id="element-14" data-mp="1vmqqwor5la7">
          ¿Es este protocolo para usted?
        </h2>

        <div className="mt-12 grid gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-15" data-mp="gr2p3dwd83ce">
          <div data-id="element-16" data-mp="bsrfn49zfuup">
            <h3 className="font-sans text-lg font-bold uppercase tracking-wide text-teal" data-id="element-17" data-mp="btaxym3jol99">
              Sí, si usted es…
            </h3>
            <ul className="mt-6 space-y-5" data-id="element-18" data-mp="ljm1w8n8aug5">
              {forYou.map(item => <li key={item} className="flex gap-4" data-id="element-19" data-mp="llqdlcrdcxqz">
                  <CheckIcon className="mt-1 h-6 w-6 flex-none text-teal" aria-hidden="true" data-id="element-20" data-mp="zkgb2ti3ozfv" />
                  <p className="font-sans text-xl leading-relaxed text-ink" data-id="element-21" data-mp="uihatshnqin5">
                    {item}
                  </p>
                </li>)}
            </ul>
          </div>

          <div className="border-t border-teal/10 pt-10 lg:border-l lg:border-t-0 lg:pl-16 lg:pt-0" data-id="element-22" data-mp="1bdw4cotnc8hj">
            <h3 className="font-sans text-lg font-bold uppercase tracking-wide text-inkSoft" data-id="element-23" data-mp="1gdih6x5kbmpt">
              No, si usted…
            </h3>
            <ul className="mt-6 space-y-5" data-id="element-24" data-mp="1pcm123ck065d">
              {notForYou.map(item => <li key={item} className="flex gap-4" data-id="element-25" data-mp="1uadqmqpq7g6e">
                  <MinusIcon className="mt-1 h-6 w-6 flex-none text-inkSoft/60" aria-hidden="true" data-id="element-26" data-mp="1u8ucb5nmrf79" />
                  <p className="font-sans text-xl leading-relaxed text-inkSoft" data-id="element-27" data-mp="23zoxs7t1yarn">
                    {item}
                  </p>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}